/**
 * Централизованная функция сброса состояний аутентификации.
 * Используется при ошибках токена, логауте и других случаях сброса auth состояния.
 * Синхронизируется между вкладками через RxDB подписку на signedIn.
 */
export default async function clearAuthState(): Promise<void> {
	// Очищаем глобальное состояние пользователя
	R.user = undefined

	// Сбрасываем все auth состояния в RxDB
	await R.db.states.auth.set('token', () => undefined)
	await R.db.states.auth.set('user', () => undefined)
	await R.db.states.auth.set('signedIn', () => false)

	log.info('Auth state cleared')
}

/**
 * Упрощенная функция для инициации сброса auth состояния.
 * Устанавливает только signedIn = false, остальной сброс происходит
 * автоматически через подписку на signedIn в auth модулях.
 */
export async function triggerAuthClear(): Promise<void> {
	await R.db.states.auth.set('signedIn', () => false)
}